import React, { useRef } from 'react';
import { IonModal } from '@ionic/react';
import { OverlayEventDetail } from '@ionic/react/dist/types/components/react-component-lib/interfaces';
import './AppModal.css';

type AppModalProps = {
  isOpen: boolean;
  close: () => void;
  children?: React.ReactNode;
};

export default function AppModal({ isOpen, close, children }: AppModalProps) {
  const modal = useRef<HTMLIonModalElement>(null);

  function onWillDismiss(event: CustomEvent<OverlayEventDetail>) {
    close();
  }

  return (
    <>
      <IonModal
        ref={modal}
        className="custommodal"
        isOpen={isOpen}
        onWillDismiss={(event) => onWillDismiss(event)}
      >
        <div className="wrapper">{children}</div>
      </IonModal>
    </>
  );
}
